import { Injectable } from '@angular/core';
import { Observable, defer, of, EMPTY } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { LsJupiterProductManagementService } from '../../services/product-management/ls-product-management.service' ;//'../../services/ls-product-management.service';
import { ProductState } from './_reducers';
import { SetProductsResults, GetAllUserProducts, ProductActionTypes } from './_actions';
import { IDisplayResultValue, Tag } from '../../models/display-result.model';
import { mergeMap, catchError, map } from 'rxjs/operators';

@Injectable()
export class ProductEffects {

  constructor(private actions$: Actions, private service: LsJupiterProductManagementService, private store: Store<ProductState>) { }

  determineTagColor(color: string) {
    switch (color) {
      case 'purple': {
        return 'ls-purple tag p-1';
      }
      case 'orange': {
        return 'ls-orange tag p-1';
      }
      case 'lightgreen': {
        return 'ls-lightgreen tag p-1';
      }
      case 'blue': {
        return 'ls-blue tag p-1';
      }
      case 'lightblue': {
        return 'ls-lightblue tag p-1';
      }
      case 'silver': {
        return 'ls-silver tag p-1';
      }
      case 'darkgreen': {
        return 'ls-darkgreen tag p-1';
      }
      case 'lightorange': {
        return 'ls-lightorange tag p-1';
      }
      case 'yellow':{
        return 'ls-yellow';
      }
      case 'green':{
        return 'ls-green';
      }
      case 'darkblue':{
        return 'ls-darkblue';
      }
      case 'lightgrey':{
        return 'ls-lightgrey';
      }
      case 'bluegrey':{
        return 'ls-bluegrey';
      }
      default:
        return 'ls-purple tag p-1';
    }
  }

  
  getAllProducts$ = createEffect(() => this.actions$.pipe(
    ofType(ProductActionTypes.GetAllUserProducts),
    mergeMap(() => this.service.GetAllUserProducts()
      .pipe(
        map(products => {
          (products as any).forEach(product => {
            if (product.hasOwnProperty('tags')) {
              if (product['tags']) {
                product.displayTags = [];
                let tags = product['tags'].split(';', 8);
                tags.forEach((item, i) => {
                  let itemAttr = item.split(',', 2);
                  if (itemAttr.length === 2) {
                    let t: Tag = {
                      tagValue: itemAttr[0],
                      color: this.determineTagColor(itemAttr[1])
                    };
                    product.displayTags.push(t);
                  }
                });
              }
            }
          });
          return new SetProductsResults({ results: products as IDisplayResultValue[] })
        }),
        catchError(() => EMPTY)
      ))
  ));



}


